



























import Vue from "vue";
import * as routes from "@/router/routes";

// Vuex
import { RootState } from "@/store";
import { mapMutations, mapState } from "vuex";
import * as m from "@/store/modules/LicenseModule/mutations";
import * as m_device from "@/store/modules/DevicesModule/mutations";

// Vue components
import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import LicensesMainTable from "./LicensesMainTable.vue";
import SummaryTable from "./SummaryTable.vue";
import LicensesStatus from "./LicensesStatus.vue";
import UploadAuthActionCard from "@/components/AuthActions/UploadAuthActionCard.vue";

// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { GetInstallationsEnabledModulesReqData, GetServerInstallationsEnabledModulesReqData } from "@/model/communication/license/GetInstallationsEnabledModulesReqData";
import { GetInstallationsEnabledModulesCommand } from "@/model/communication/license/GetInstallationsEnabledModulesCommand";
import { EditInstallationsEnabledModulesCommand } from "@/model/communication/license/EditInstallationsEnabledModulesCommand";
import { DownloadInstallationsEnabledModulesCommand } from "@/model/communication/license/DownloadInstallationsEnabledModulesCommand";
import { GetInstallationsResData } from "@/model/communication/device/GetInstallationsResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ServiceResponseData } from "@/model/communication/ServiceResponseData";
import { GetLicensesDataSummaryResData } from "@/model/communication/license/GetLicensesDataSummaryResData";
import { GetLicensesDataSummaryCommand } from "@/model/communication/license/GetLicensesDataSummaryCommand";
import { AssignToAllResData, LicenseModulesAssignToAllCommand } from "@/model/communication/license/LicenseModulesAssignToAllCommand";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { ClientUser } from "@/model/data/authentication/ClientUser";

export default Vue.extend({
    components: {
        StandardPage,
        SummaryTable,
        LicensesStatus,
        UploadAuthActionCard,
    },
    data() {
        return {
            routes,
            dataTableItemsPerPage,
            LicensesMainTable,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            loading: false,
            loadingSummary: false,
        };
    },
    computed: {
        ...mapState({
            localInstallations: (state: RootState) => state.license.localInstallations,
            authUser: (state: RootState) => state.authMod.currentUser,
        }),

        authActionsEnabled() {
            return (this.authUser as ClientUser).profile.privileges.and(ClientPrivileges.AuthActions) == ClientPrivileges.AuthActions;
        },

        isSaveButtonEnable() {
            var isDifferent = false;

            if (this.installations && this.installations.length > 0 && this.localInstallations && this.localInstallations.length > 0) {
                this.installations.forEach((serverInstallation) => {
                    if (this.localInstallations.filter((i) => i.name == serverInstallation.name).length > 0) {
                        if (this.localInstallations.filter((i) => i.name == serverInstallation.name)[0].licenseData.enabledModules != serverInstallation.licenseData.enabledModules)
                            isDifferent = true;
                    }
                });
            }
            return isDifferent;
        },
    },
    methods: {
        ...mapMutations([m.SET_INSTALLATIONS, m.SET_LICENSES_DATA_SUMMARY, m_device.RESET_DEVICE_TREE]),

        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                let response: GetInstallationsResData = await new GetInstallationsEnabledModulesCommand(GetServerInstallationsEnabledModulesReqData(request)).execute();
                this.loading = false;

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installations;
                    this[m.SET_INSTALLATIONS](this.installations);
                    this.paginatedTotalItems = response.paginatedTotalItems;
                }
            } catch (e) {
                console.log("Something went wrong sending GetInstallationsEnabledModules request ", e);
                this.loading = false;
            }
        },

        async sendLicensesDataSummaryRequest() {
            try {
                this.loadingSummary = true;
                let responseSummary: GetLicensesDataSummaryResData = await new GetLicensesDataSummaryCommand().execute();
                this.loadingSummary = false;

                if (responseSummary.responseStatus == ApiResponseStatusEnum.Success) {
                    this[m.SET_LICENSES_DATA_SUMMARY](responseSummary.modules);
                }
            } catch (e) {
                console.log("Something went wrong sending GetLicensesDataSummary request ", e);
                this.loadingSummary = false;
            }
        },

        async onSubmit() {
            // mando solo le installazioni che sono state modificate
            let installationsToSend = [];
            if (this.installations != null && this.installations.length > 0 && this.localInstallations != null && this.localInstallations.length > 0) {
                this.installations.forEach((installation) => {
                    let currentLocalInstallation = this.localInstallations.filter((i) => i.name == installation.name)[0];
                    if (currentLocalInstallation.licenseData.enabledModules != installation.licenseData.enabledModules)
                        installationsToSend.push({
                            name: installation.name,
                            enabledModules: currentLocalInstallation.licenseData.enabledModules,
                        });
                });
            }

            try {
                this.loading = true;
                let response: ServiceResponseData = await new EditInstallationsEnabledModulesCommand(installationsToSend).execute();
                this.loading = false;

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.sendLicensesDataSummaryRequest();
                    this.sendRequest(this.reqData);
                }
            } catch (e) {
                console.log("Something went wrong sending EditInstallationsEnabledModules request ", e);
                this.loading = false;
            }
        },

        async assignToAll(licenseModule) {
            console.debug("Send assignToAll module: ", licenseModule);

            try {
                this.loadingSummary = true;
                let response: AssignToAllResData = await new LicenseModulesAssignToAllCommand({ licenseModule: licenseModule }).execute();
                this.loadingSummary = false;

                console.debug("response: ", response);

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    if (response.installationNames != null && response.installationNames.length > 0) {
                        this.sendLicensesDataSummaryRequest();
                        this.sendRequest(this.reqData);
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending assignToAll request ", e);
                this.loadingSummary = false;
            }
        },

        async onDownload(exportType) {
            console.log("Download required, exportType: ", exportType);
            if (!this.loading) {
                this.loading = true;
                try {
                    const res = await new DownloadInstallationsEnabledModulesCommand(GetServerInstallationsEnabledModulesReqData(this.reqData), exportType).execute();

                    let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.loading = false;
                } catch (e) {
                    console.log("Something went wrong during DownloadInstallationsEnabledModulesCommand execution: ", e);
                    this.loading = false;
                }
            }
        },

        onAuthActionExecuted() {
            this.sendLicensesDataSummaryRequest();
            this.sendRequest(this.reqData);
            // cancello l'albero eventualmente salvato in vuex
            this[m_device.RESET_DEVICE_TREE]();
        },
    },
    mounted() {
        this.reqData = new GetInstallationsEnabledModulesReqData();
        this.reqData.queryLimit = this.dataTableItemsPerPage[0];
        this.sendLicensesDataSummaryRequest();
    },
});
